module.exports = __webpack_public_path__ + "static/bebauung4-c59c7d2c04e5d3d58e3f03c1b42a9cb2.png";